import AddIndividualDrawer from './AddIndividualDrawer';

export default AddIndividualDrawer;
